<template>
  <div>
    <div style="width:172px" :style="{'height':height}" :id="id"></div>
  </div>
</template>

<script>
import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../utils/util'
// import { TooltipComponent, LegendComponent } from 'echarts/components'
// import { PieChart } from 'echarts/charts'
// import { CanvasRenderer } from 'echarts/renderers'
// echarts.use([TooltipComponent, LegendComponent, PieChart, CanvasRenderer])
export default {
  mixins: [chartResize],
  name: 'RingEchart',
  components: {},
  data () {
    return {
      id: getUUID()
    }
  },
  myChart: null,
  unwatch: null,
  props: {
    // id: {
    //   type: String,
    //   default: ''
    // },
    data: {
      type: Array,
      default: null
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  methods: {
    drawRingGraph () {
      const _this = this
      this.myChart = echarts2.init(document.getElementById(_this.id))
      this.unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set (data) {
      var option
      var data = this.data
      option = {
        tooltip: {
          trigger: 'item',
            formatter: function (params) {
              console.log(params)
              var allData = 0
              var result = ''
              result +=
                '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background:' +
                  params.color.colorStops[0].color +
                '"></span>'
              result += params.data.name + '<br>'
              // result += '&nbsp&nbsp&nbsp数量 ：' + params.data.value + '<br>'
              result += '&nbsp&nbsp&nbsp占比 ：' + params.data.value + '%' + '<br>'
              return result
            }
        },
        color: [
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#0257BE' },
            { offset: 1, color: '#109BFF' }
          ]),
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#5C57FF' },
            { offset: 1, color: '#2C37FE' }
          ]),
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#FFD275' },
            { offset: 1, color: '#F3892B' }
          ]),
          new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#02FFFF' },
            { offset: 1, color: '#01C7FF' }
          ])
        ],
        legend: {
          bottom: '7%',
          right: '10%',
          //   orient: 'vertical', //垂直显示
          padding: 5, // 调节legend的位置
          textStyle: {
            fontSize: 12,
            color: '#98BDFF'
          }
        },
        series: [
          {
            center: ['50%', '26%'],
            // name: '访问来源',
            type: 'pie',
            radius: ['30%', '60%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.data
          }
        ]
      }

      this.myChart.setOption(option)
      this.chartEleResizeListener()
    }
  },
  mounted () {
    this.drawRingGraph()
  },
  created () {},
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (!this.myChart?.isDisposed) {
      this.myChart.dispose()
    }
  }
}
</script>
<style lang="less" scoped>
</style>
